import { Moment } from "moment";
import { mutatorAction } from "satcheljs";
import { OpenShiftStore } from "../";

export default mutatorAction('SET_OPEN_SHIFTS_CACHE_END_TIME_IN_STORE', function setOpenShiftsCacheEndTimeInStore(cacheEndTime: Moment) {
    OpenShiftStore().cacheEndTime = cacheEndTime;
});
